<template>
  <div class="it-mortgage__table">
    <div class="it-mortgage__default" v-if="content.length <= 2">
      <div v-if="!isFirstStart" class="it-mortgage__default-block">
        <p class="it-mortgage__default-text h-24 h-m-16">
          К&nbsp;сожалению, по&nbsp;Вашему запросу ничего не&nbsp;найдено.
        </p>
        <button class="button button_type_secondary" @click.prevent="$emit('onreset')">Сбросить фильтры</button>
      </div>
    </div>
    <div class="it-mortgage__content" v-else>
      <div
        v-if="header && header.length"
        class="it-mortgage__header d-none d-md-block"
      >
        <div class="it-mortgage__row it-mortgage__row_title">
          <div class="it-mortgage__cell it-mortgage__cell_main">
            {{ header[0] }}
          </div>
          <div
            class="it-mortgage__cell d-none d-lg-block"
            v-for="(item, idx) in header.slice(2)"
            :key="idx"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="it-mortgage__body">
        <template
          v-for="(item, idx) in rowsData"
          :key="`row-${item.id}-${idx}`"
        >
          <!-- Строка все кредиторы/регионы -->
          <template v-if="item.id === 'all'">
            <div class="it-mortgage__row">
              <div class="it-mortgage__cell it-mortgage__cell_main">
                {{ item.title }}
              </div>
              <div
                  v-for="(col, idx) in item.cols"
                  :key="`row-${item.id}-col-${idx}`"
                  class="it-mortgage__cell"
                  :class="{ '_mob-active-col': isMobActiveCol(idx) }"
              >
                {{ col }}
              </div>
            </div>
          </template>
          <!-- Строка c селектом -->
          <template v-if="item.isParent">
            <div
                class="it-mortgage__row it-mortgage__row_select"
                :class="{ 'is-open': curActiveTitles.includes(item.id) }"
                @click="setCurActiveId(item.id)"
            >
              <div class="it-mortgage__cell it-mortgage__cell_main">
                <span class="it-mortgage__select">
                  {{ item.title }}
                </span>
              </div>
              <div
                v-for="(col, idx) in item.cols"
                :key="`row-${item.id}-col-${idx}`"
                :class="{ '_mob-active-col': isMobActiveCol(idx) }"
                class="it-mortgage__cell"
              >
                {{ col }}
              </div>
            </div>
          </template>
          <!-- Строка внутри селекта -->
          <template v-else>
            <div
              class="it-mortgage__row it-mortgage__row_hide"
              :class="{ 'is-show': curActiveTitles.includes(item.id) }"
            >
              <div class="it-mortgage__cell it-mortgage__cell_main">
                <span>{{ item.title }}</span>
              </div>
              <div
                  v-for="(col, idx) in item.cols"
                  :key="`row-${item.id}-col-sub-${idx}`"
                  :class="{ '_mob-active-col': isMobActiveCol(idx) }"
                  class="it-mortgage__cell"
              >
                {{ col }}
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportTable',
  props: {
    header: {
      type: Array,
      default() {
        return [];
      }
    },
    content: {
      type: Array,
      default() {
        return [];
      }
    },
    curMobId: {
      type: Number,
      default: 1
    },
    activeTab: {
      type: String,
      default: 1
    },
    isFirstStart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      curActiveTitles: [],
      deviceType: 'desktop'
    };
  },
  computed: {
    rowsData() {
      const resultData = [];
      let curIdx = '';

      this.content.forEach((item, idx) => {
        if (idx === 0) {
          // общий результат приходит первым
          resultData.push({
            title: item[0],
            cols: item.slice(2),
            id: 'all'
          });
        } else {
          if (item[1].length === 0) {
            resultData.push({
              title: item[0],
              cols: item.slice(2),
              id: item[0],
              isParent: true // может открываться при нажатии
            });
            curIdx = item[0];
          } else {
            // console.log('subitem', '0 | ', item[0], ' 1  |', item[1], this.activeTab)
            resultData.push({
              title: item[1],
              cols: item.slice(2),
              id: curIdx
            });
          }
        }
      });

      return resultData;
    },
  },
  methods: {
    setCurActiveId(title) {
      const alreadyIsset = this.curActiveTitles.includes(title);
      if (alreadyIsset) {
        this.curActiveTitles = this.curActiveTitles.filter(item => item !== title);
      } else {
        this.curActiveTitles.push(title);
      }
    },
    onResize() {
      if (window.innerWidth > 1123) {
        this.deviceType = 'desktop';
      } else if (window.innerWidth < 768) {
        this.deviceType = 'mobile';
      } else {
        this.deviceType = 'tablet';
      }
    },
    isMobActiveCol(idx) {
      if (this.deviceType === 'desktop') return false;

      return idx === this.curMobId;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  }
}
</script>